var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRouter && _vm.to)?_c('router-link',{attrs:{"to":_vm.to}},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.label)+" ")],2):_c('a',{attrs:{"href":_vm.to,"title":_vm.title}},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.label)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }